import {useEffect, useState} from "react";

const isVisible = () => typeof document === 'undefined' || document.visibilityState !== 'hidden';

/** true, пока вкладка браузера видима (Page Visibility API). */
export default function usePageVisible() {
    const [visible, setVisible] = useState(isVisible);
    useEffect(() => {
        const handleChange = () => setVisible(isVisible());
        document.addEventListener('visibilitychange', handleChange);
        return () => document.removeEventListener('visibilitychange', handleChange);
    }, []);
    return visible;
}
